<template>
  <div :class="prefixCls">
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
      @change="onEditorChange($event)"
      @click.native="handleEditAblequestion">
    </quill-editor>

  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'QuillEditor',
  components: {
    quillEditor
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-editor-quill'
    },
    // 表单校验用字段
    // eslint-disable-next-line
    initValue: {
      type: [String, Number],
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      qillInit: true,
      content: this.initValue,
      editorOption: {
        // some quill options
      }
    }
  },
  mounted() {
    this.$refs.myQuillEditor.quill.enable(false)
  },
  methods: {
    // 点击富文本重新获取焦点
    handleEditAblequestion () {
      if (this.qillInit) {
        this.$refs.myQuillEditor.quill.enable(true)
        this.$refs.myQuillEditor.quill.focus()
        this.qillInit = false
      }
    },
    // 失去焦点事件
    // eslint-disable-next-line no-unused-vars
    onEditorBlur(quill) {
      // console.log('editor blur!', quill)
    },
    // 获得焦点事件
    // eslint-disable-next-line no-unused-vars
    onEditorFocus(quill) {
      // console.log('editor focus!', quill)
    },
    // 准备富文本编辑器
    // eslint-disable-next-line no-unused-vars
    onEditorReady(quill) {
      // console.log('editor ready!', quill)
    },
    // 内容改变事件
    // eslint-disable-next-line no-unused-vars
    onEditorChange({ quill, html, text }) {
      // console.log('editor change!', quill, html, text)
      this.$emit('change', html)
    }
  },
  watch: {
    initValue (val) {
      this.content = val
    }
  }
}
</script>

<style lang="less" scoped>
/*@import url('../index.less');*/

/* 覆盖 quill 默认边框圆角为 ant 默认圆角，用于统一 ant 组件风格 */

/deep/ .quill-editor .ql-container .ql-editor{
  min-height: 200px;
}
</style>
